import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * One line of the results breakdown: a label and a count in a pill, e.g.
 * "Correct  16".
 *
 * Props:
 *   id      (string) - Element ID.
 *   label   (string) - "Correct" or "Incorrect".
 *   value   (number) - How many questions fall into that group.
 *   variant (string) - 'correct' or 'incorrect'; picks the colour.
 */
export const ScoreStat = ({ id, label, value, variant }) => (
  <Box className={`scoreStat ${variant}`} id={id}>
    <Typography className="scoreStatLabel">{label}</Typography>
    <Typography className="scoreStatValue">{value}</Typography>
  </Box>
);
